<p lang="en" align="center">
    <strong>Splošni pogoji uporabe</strong>
</p>
<h6 align="justify">
    Uvodna določba
</h6>
<p align="justify">
    S temi Splošnimi pogoji uporabe ( v nadaljevanju »Splošni pogoji«) so
    določeni pogoji uporabe ter pravice in dolžnosti uporabnika (v nadaljevanju
»vi«, »vas«) ter ponudnika storitve družbe    <strong>Table42 d.o.o.</strong>, Vurnikov trg 3, 4240 Radovljica (v
    nadaljevanju »skrbnik«), v zvezi z uporabo in delovanjem naslednjih
    spletnih portalov ali mobilnih aplikacij:
</p>
<p align="justify">
    www.table42.app (v nadaljevanju »spletni portal«)
</p>
<p align="justify">
    table42.app (v nadaljevanju »aplikacija«).
</p>
<p align="justify">
    Uporabnik je vsakdo, ki obišče ali uporablja katerokoli spletno stran ali
    aplikacijo skrbnika navedeno v tem členu. Za uporabnika v smislu teh
    Splošnih pogojev se štejejo končni uporabniki, ki koristijo storitve
    table42.app.
</p>
<p align="justify">
    Splošni pogoji veljajo in zavezujejo vse vrste uporabnikov, ki uporabljajo
    spletni portal ali aplikacijo skrbnika. Splošni pogoji so sestavni del
    vsake pogodbe skrbnika z uporabnikom aplikacije ali spletnega portala,
    razen v primerih, ko je s temi ali drugimi splošnimi pogoji določeno
    drugače. Vse navedene določbe teh Splošnih pogojev poslovanja so splošni
    pogoji v smislu 120. člena Obligacijskega zakonika (Uradni list RS, št.
    97/07 in nasl.), ki dopolnjujejo pogodbo in so zavezujoči kot pogodbena
    določila.
</p>
<p align="justify">
    Z uporabo spletnega portala, aplikacije in storitev skrbnika, uporabnik
    potrjuje in soglaša, da:
</p>
<ul>
    <li>
        <p align="justify">
            je prebral in razumel ter bo spoštoval te Splošne pogoje;
        </p>
    </li>
    <li>
        <p align="justify">
            ga ti Splošni pogoji pravno zavezujejo;
        </p>
    </li>
    <li>
        <p align="justify">
            je star 18 let ali več ter je poslovno sposoben.
        </p>
    </li>
</ul>
<h6 align="justify">
    2. Registracija uporabnikov
</h6>
<p align="justify">
    Za uporabo storitev table42.app se mora uporabnik predhodno registrirati v
    aplikaciji ali na spletnem portalu. Z opravljeno registracijo uporabnik
    pridobi pravico do uporabe storitev in oddaje naročila ter rezervacije
    termina željene storitve, pri različnih ponudnikih storitev. Z registracijo
    se šteje, da uporabnik sprejme te pogoje ter soglaša z Politiko varstva
    osebnih podatkov skrbnika, objavljeno na njegovi spletni strani. Uporabnik
    mora vsa zahtevana polja izpolniti s svojimi resničnimi podatki. Izdajanje
    za drugo pravno ali fizično osebo je kaznivo dejanje.
</p>
<p align="justify">
    Uporabnik je izključno odgovoren za ustrezno ravnanje z uporabniškim
    računom in varovanje svojega uporabniškega gesla pred nepooblaščenim
    dostopom tretjih oseb. Skrbnik ne prevzema nobene odgovornosti za morebitne
    zlorabe uporabniškega računa.
</p>
<h6 align="justify">
    <a name="_Hlk39841157"></a>
    3. Uporabniške vsebine
</h6>
<p align="justify">
    table42.app je platforma za spletno naročanje uporabnikov na storitve
    različnih ponudnikov. table42.app uporabnikom storitev omogoča,
    samopostrežno in zasebno izbiro storitev ter vnaprejšnjo informacijo o ceni
    željene storitve pri ponudnikih.
</p>
<p align="justify">
    Uporabnik se zavezuje, da bo njegova uporabniška vsebina resnična in
    zakonita. Skrbnik spletnega portala in aplikacije ne odgovarja za
    uporabniške vsebine, objavljene na tej aplikaciji ali spletnem portalu.
    Uporabniške vsebine so last uporabnikov in zanje odgovarjajo sami. Kljub
    temu si skrbnik pridržuje pravico, da lahko blokira, briše ali ureja
    vsebino, za katero po lastni presoji smatra, da krši zakonodajo oziroma je
    drugače nesprejemljiva.
</p>
<p align="justify">
    Z objavo uporabniške vsebine se uporabnik strinja z njenim prikazom v
    aplikaciji in s povezano promocijsko rabo te vsebine. Uporabnik se
    zavezuje, da bo o morebitnih nepravilnostih glede objav uporabniških
    vsebin, nemudoma obvestil skrbnika portala.
</p>
<h6 align="justify">
    4. Oddaja naročila storitev in cene
</h6>
<p align="justify">
    Uporabnik odda naročilo na izbrano storitev pri izbranem ponudniku, ko po
    izbiri željenega termina storitve, v aplikaciji tega potrdi s pritiskom na
    možnost »rezerviraj«. Uporabnik prejme potrditev rezerviranega termina
    storitve na uporabnikov e-poštni naslov ali po SMS sporočilu na uporabnikov
    telefon, odvisno načina, ki ga je izbral uporabnik. Sprememba ali preklic
    naročila s strani uporabnika, je mogoča le po predhodnem dogovoru med
    uporabnikom in ponudnikom storitve. Glede možnosti spremembe ali preklica
    naročene storitve, skrbnik ne prevzema nikakršne odgovornosti.
</p>
<p align="justify">
    Uporabnik naročeno storitev plača neposredno izbranemu ponudniku storitve,
    po opravljeni storitvi. Vse cene ponudnikov storitev v aplikaciji so
    navedene v EUR in vsebujejo obračunan davek na dodano vrednost (DDV).
</p>
<h6 align="justify">
    5. Varovanje osebnih podatkov in uporabniških vsebin
</h6>
<p align="justify">
    Skrbnik obdeluje osebne podatke uporabnikov v skladu z evropsko zakonodajo
    (Uredba (EU) 2016/697 o varstvu posameznikov pri obdelavi osebnih podatkov
    in o pretoku takih podatkov (v nadaljevanju: Splošna uredba ali GDPR)) in
    veljavno slovensko zakonodajo s področja varstva osebnih podatkov ter
    internimi akti. Informacije o obdelavi osebnih podatkov in o pravicah
    posameznikov, ki iz nje izvirajo so podrobneje opredeljene v Politiki
    zasebnosti objavljeni na: ( vstavite link do objavljene politike).
</p>
<p align="justify">
    Med trajanjem pogodbe in še po njej, lahko skrbnik uporabi neosebne oz.
    anonimizirane podatke za izboljšanje storitve, statistične analize,
    tehnično podporo in druge poslovne namene.
</p>
<p align="justify">
    Skrbnik bo osebne podatke, ki mu jih bo posredoval uporabnik, obdeloval za
    namene zagotavljanja pravic uporabnika iz te pogodbe, za preverjanje
    skladnosti uporabe aplikacije s splošnimi pogoji poslovanja, za
    analiziranje in proučevanja uporabniških navad, za namen ocenjevanja
    ponudbe, za namen predvidevanja uporabnikovih interesov, ekonomskega
    položaja in optimiziranja ponudb ter stroškov, za dvig zadovoljstva kupcev,
    pri reševanju vaših vprašanj, pobud, ugovorov ali reklamacij, za obveščanje
    o tehničnih, pravnih in drugih vprašanjih. Občasno bo skrbnik uporabnika
    zaprosil za povratne informacije o zadovoljstvu z uporabo storitve. Podatke
    uporabnika bo skrbnik lahko uporabljal tudi za namene neposrednega trženja
    in za uporabnika pripravili posebne ponudbe ter ga o njih obvestil na
    način, ki ga bo uporabnik sam izbral (na e-naslov, sms, ali v aplikaciji).
</p>
<p align="justify">
    Uporabnik ne more ugovarjati drugim namenom obdelave osebnih podatkov, ki
    se nanašajo nanj, v zvezi z uporabo, razen na način, da odstopi od pogodbe
    v skladu s temi splošnimi pogoji. V tem primeru mora ukiniti uporabniški
    račun.
</p>
<p align="justify">
    Skrbnik ne posreduje osebnih podatkov uporabnikov tretjim, razen:
</p>
<ul>
    <li>
        <p align="justify">
            zunanjim pogodbenim izvajalcem, ki podatke obdelujejo izključno v
            imenu, za račun, po navodilih in pod nadzorom skrbnika (npr. klicni
            centri, tiskarji, oglaševalske agencije);
        </p>
    </li>
    <li>
        <p align="justify">
            državnim organom na podlagi njihove obrazložene zahteve za potrebe
            vodenja konkretnega postopka;
        </p>
    </li>
    <li>
        <p align="justify">
            če se izkažejo s pisno osebno privolitvijo oziroma pooblastilom
            uporabnika.
        </p>
    </li>
</ul>
<h6 align="justify">
    6. Uporabniška podpora
</h6>
<p align="justify">
    Skrbnik vsem uporabnikom nudi strokovno in tehnično pomoč pri uporabi
    spletnega portala ali aplikacije, in sicer v rednem delovnem času skrbnika.
    Če ima uporabnik kakršno koli vprašanje ali težavo v zvezi z uporabo
    spletnega portala/aplikacije, lahko svojo prošnjo pošlje na elektronski
    naslov: <em>stik@table42.app</em>
</p>
<h6 align="justify">
    7. Avtorske pravice
</h6>
<p align="justify">
    Vsebina spletnega portala in aplikacije je v lasti skrbnika in zato
    avtorsko zaščitena z veljavnimi zakoni. V vsebino je vključena tudi
    grafična podoba spletnega portala in aplikacije z vsemi grafičnimi
    elementi. Vsakršno kopiranje in objavljanje te vsebine na drugih spletnih
    mestih ali aplikacijah je prepovedano, razen v primeru pisnega dovoljenja
    skrbnika.
</p>
<h6 align="justify">
    8. Omejitev odgovornosti
</h6>
<p align="justify">
    Uporabnik se obvezuje, da spletnih strani in aplikacij skrbnika navedenih v
    prvem členu teh pogojev, ne bo uporabljal za nezakonite namene ali namene,
    ki bi lahko škodovali skrbniku ali drugim uporabnikom. Ravno tako ni
    dovoljeno onemogočanje ali oviranje uporabe drugim njegovim uporabnikom.
    Skrbnik ne odgovarja za pravilnost ter ažurnost podatkov, ki jih objavi
    uporabnik in ne prevzema odgovornosti za dejanja, ki jih uporabnik opravi
    na podlagi objavljenih podatkov. Skrbnik ni odgovoren za kakršnokoli škodo,
    ki bi izvirala iz morebitnih tehničnih težav ali drugih motenj.
</p>
<p align="justify">
    Strani in aplikacije navedene v prvem členu teh pogojev lahko vsebujejo
    tudi povezave na spletna mesta tretjih oseb. Skrbnik ne prevzema
    odgovornosti za spoštovanje zasebnosti in vsebino na teh spletnih mestih.
    Skrbnik prav tako ne jamči (ne pogodbeno niti odškodninsko ali kakor koli
    drugače) za kakršno koli izgubo ali škodo, ki bi nastala kot posledica
    uporabe ali nezmožnost uporabe, izgubo ali napake v podatkih in točnosti
    podatkov.
</p>
<p align="justify">
    9. Trajanje in prenehanje pogodbe
</p>
<p align="justify">
    Uporabnik z uporabo storitev table42.app v aplikaciji ali spletnem portalu
    s skrbnikom sklene pogodbo o uporabi storitev table42.app, katere sestavni
    del so ti Splošni pogoji. Ta pogodba je sklenjena za nedoločen čas.
    Uporabnik ima pravico odstopiti od pogodbe, kar lahko naredi z ustrezno
spremembo nastavitev v aplikaciji ali z obvestilom po elektronski pošti na    <em>stik@table42.app)</em>, ali pisno po priporočeni pošti na naslov
    sedeža skrbnika, vendar se mora v izogib zlorabam najprej izkazati kot
    uporabnik.
</p>
<p align="justify">
    V primeru, če uporabnik huje krši pravila glede primernega nivoja
    komuniciranja (nadlegovanje, žaljiv govor, diskriminiranje ipd.), izvaja
    aktivnosti, ki so v nasprotju s pogodbo, temi splošnimi pogoji ali
    zakonodajo, ima skrbnik pravico nemudoma odstopiti od pogodbe in trajno ali
    začasno blokirati oz. izbrisati uporabniški račun.
</p>
<p align="justify">
    Skrbnik si pridržuje pravico, da lahko brez odpovednega roka odstopi od
    pogodbe, brez navedbe razloga.
</p>
<h6 align="justify">
    10. Reševanje sporov
</h6>
<p align="justify">
    Za vsa vprašanja glede strukture, veljavnosti, uveljavljanja in razlage teh
    Splošnih pogojev se uporablja pravo Republike Slovenije. Morebitne spore,
    nastale zaradi kršitev teh Splošnih pogojev, si bo skrbnik portala
    prizadeval reševati po mirni poti. Za reševanje sporov, za katere se izčrpa
    vse ostale zunaj sodne možnosti sporazuma, je pristojno stvarno pristojno
    sodišče po sedežu skrbnika.
</p>
<h6 align="justify">
    11. Končna določba
</h6>
<h6 align="justify">
</h6>
<p align="justify">
    Skrbnik ima pravico dopolniti, popraviti ali spremeniti Splošne pogoje
    poslovanja. V tem primeru bo pred njihovo uveljavitvijo seznanil uporabnika
    tako, da mu pošlje predlog spremembe splošnih pogojev (e-mail, obvestilo na
    spletnem portalu ali v aplikaciji). Če uporabnik ne soglaša s spremembami
    splošnih pogojev, lahko brez odpovednega roka odstopi od pogodbe, sklenjene
    na podlagi teh Splošnih pogojev. Odpoved uporabnika se šteje za veljavno,
    če je podana na način določen v 8.členu teh Splošnih pogojev. Nadaljnja
    uporaba storitev skrbnika po začetku veljavnosti novih pogojev pomeni
    strinjanje uporabnika s temi pogoji.
</p>
<p align="justify">
    Za kakršnokoli vprašanje ali pripombe glede teh Splošnih pogojev, je
skrbnik uporabniku na voljo na e-poštnem naslovu    <em>stik@table42.app</em>
</p>
<p align="justify">
    Ti splošni pogoji veljajo in se uporabljajo od 1.10.2022 dalje.
</p>
<p align="justify">
    V Radovljici, 1.10.2022
</p>